import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {StorageUtils} from '../../utils';

@Injectable()
export class LoginService {
    andebug = false;

    constructor(private http: Http) {
        this.andebug = StorageUtils.getItem('an.debug') === 'd' ? true : false;
    };

    getAccessTokenCheck(tokenValue): Promise<any> {
        const url = `${global['urlInfo'].ssoUrl}oauth/validate_token?token=${tokenValue}`;
        if (this.andebug) console.log('>>> getAccessTokenCheck(tokenValue): ' + url);

        return this.http
            .get(url)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getClientId(): Promise<any> {
        const url = `${global['urlInfo'].ssoUrl}oauth/clientId`;
        if (this.andebug) console.log('>>> getClientId(): ' + url);

        return this.http
            .get(url)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    private handleError(error: any) {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/src/login.service.ts